<div class="channels">
  <div *ngFor="let channel of channels" class="channel">
    <div
      *ngIf="channel.tasks_ids; else loading"
      class="counter"
      [ngClass]="{ zero: !channel.tasks_ids.length, all: !channel.typeString }"
      [innerHTML]="channel.tasks_ids.length | truncateCounter"></div>
    <ng-template #loading>
      <div class="counter zero">...</div>
    </ng-template>

    <img *ngIf="channel.typeString" class="icon" [src]="'assets/img/site_icon/v2/' + channel.typeString + '.png'" />
    <div class="name alc-ellipsis">{{ channel.taskTypeString }}</div>
  </div>
</div>
